import { useEffect, useState } from 'react';

/**
 * Whether the browser thinks it can reach the network.
 *
 * navigator.onLine only knows about the link, not whether anything answers on
 * it -- captive portals and dead party wifi both report online. Treat it as a
 * hint for the UI, never as a reason to skip a request.
 */
export const useOnline = (): boolean => {
    const [online, setOnline] = useState(() => navigator.onLine);

    useEffect(() => {
        const up = (): void => setOnline(true);
        const down = (): void => setOnline(false);
        window.addEventListener('online', up);
        window.addEventListener('offline', down);
        return () => {
            window.removeEventListener('online', up);
            window.removeEventListener('offline', down);
        };
    }, []);

    return online;
};
